// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"801":"5ab2d071","916":"5ab2d071"}[chunkId] + ".chunk.css";
};